import { toDisplayString as _toDisplayString, withModifiers as _withModifiers, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, renderSlot as _renderSlot, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["data-bs-title", "hidden", "disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("button", {
      "data-bs-toggle": "tooltip",
      "data-bs-placement": "top",
      "data-bs-title": _ctx.tooltipCase(),
      hidden: _ctx.specialCase(),
      disabled: _ctx.attributeCheck(_ctx.statTypeEnum.Disabled),
      class: _normalizeClass(_ctx.getValue(_ctx.statTypeEnum.Design)),
      onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.regionType.RegionTypes[_ctx.object.Region].ObjectTypes[_ctx.object.ObjectEnum].ChooseSubType(_ctx.object)), ["prevent"]))
    }, _toDisplayString(_ctx.getValue(_ctx.statTypeEnum.Label)), 11, _hoisted_1),
    _renderSlot(_ctx.$slots, "default")
  ], 64))
}